import { createSlice } from "@reduxjs/toolkit";

const fieldNotesSlice = createSlice({
  name: "fieldNotes",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    fetchFieldNotesStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchFieldNotesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchFieldNotesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchFieldNotesStart,
  fetchFieldNotesSuccess,
  fetchFieldNotesFailure,
} = fieldNotesSlice.actions;
export default fieldNotesSlice.reducer;
